<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Logo',
})
</script>
<template>
  <div class="logo">
    <!-- <router-link :to="{ name: 'dashboard' }"> -->
    <img src="@/assets/pc_logo.png" alt="" style="width: 148px; height: 35px;">
    <!-- <SvgIcon name="logo" /> -->
    <!-- <h1 v-if="showTitle">{{ title }}</h1> -->
    <!-- </router-link> -->
  </div>
</template>

<script lang="ts" setup name="Logo">
import SvgIcon from '@/components/SvgIcon/index.vue'

const props = defineProps({
  title: {
    type: String,
    default: '上海古北九九艺术中心',
    required: false
  },
  showTitle: {
    type: Boolean,
    default: true,
    required: false
  }
})
</script>

<style lang="less" scoped>
.logo {
  background-color: #323232 !important;
}
</style>
